
export const Servicesofweb = [
  {
    title: "UI/UX",
    description: `Designing interfaces that are not only 
visually stunning but also effortless to 
use. Every click, swipe, and scroll is 
shaped to deliver delight — by 
VisionBird.`,
    image: "/assets/Images/Calling-bro-1.png",  // ✅ from public folder
  },
  {
    title: "Front & Back-End",
    description: `From pixel-perfect front-end visuals 
to powerful, secure back-end systems, 
we build it all. A seamless marriage of 
form and function — by VisionBird.`,
    image: "/assets/Images/Messages-pana-1.png",
  },
  {
    title: "Responsive Design",
    description: `Your brand, flawlessly adapted to every 
screen, from mobile to widescreen. 
Consistency, speed, and elegance 
everywhere — by VisionBird.`,
    image: "/assets/Images/Paper-map-cuate-1.png",
  },
];

export const ServicesOfGraphic = [
{  title: "Creative Designs",
    description: `We create unique, brand-focused visuals that capture your identity. Our goal is to make your business stand out in a crowded market.`,
    image: "/assets/Images/Calling-bro-2.png",  // ✅ from public folder
  },
  {
    title: "Professional Layouts",
    description: `Clean, organized, and aesthetically 
balanced designs for all media. 
Perfectly crafted for both print 
materials and digital platforms.`,
    image: "/assets/Images/Messages-pana-2.png",
  },
  {
    title: "Engaging Graphics",
    description: `High-quality visuals designed to attract 
and retain audience attention. We use 
impactful elements to boost interaction 
and brand recall.`,
    image: "/assets/Images/Paper-map-cuate-2.png",
  },
];

export const ServicesofMotion = [
  {  title: "Smooth Animation",
    description: `We produce fluid, eye-catching animations that bring ideas to life. Each project is crafted to tell your story in a dynamic way.`,
    image: "/assets/Images/Calling-bro-3.png",  // ✅ from public folder
  },
  {
    title: "Creative Motion",
    description: `Unique motion graphics designed to 
match your brand’s personality. 
Perfect for ads, social media, and 
promotional videos.`,
    image: "/assets/Images/Messages-pana-3.png",
  },
  {
    title: "Engaging Visuals",
    description: `Striking animated elements that 
capture attention instantly. Our work 
keeps viewers hooked from start to 
finish.`,
    image: "/assets/Images/Paper-map-cuate-3.png",
  },
];
